import script from "./HomeSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSlider.vue?vue&type=script&setup=true&lang=js"

import "./HomeSlider.vue?vue&type=style&index=0&id=094b8570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-094b8570"]])

export default __exports__